export enum LabelAlignmentStyle {
  Left = 'Left',
  Right = 'Right',
}
